 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		45: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		45: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-locations-LocationsPage-LocationsPage","39":"app-components-search-Search-SearchContainer","40":"app-components-search-SearchPrintList-SearchPrintListContainer","41":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","42":"app-components-shelves-Shelf-ShelfContainer","43":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","44":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"415f85debcee4b00e90f","1":"2e2f20d579f7506e61e5","2":"04675822b9035bad4c9b","3":"eb256da63290cba67cd6","4":"177969e0d4ea13023047","5":"fb7de50083de7561a10e","6":"d067f854c1e3fe1913da","7":"3b227b541f5112933273","8":"dcc07c1abe961fdd1641","9":"681fae6f0fe019ba742b","10":"6e01d2f0fa211ad052e2","11":"154326f599384d6d3efd","12":"1b43193ba3c3709611f2","13":"470cfc0897865b12b042","14":"35c5d1274efb5924daf6","15":"4a430e64ba17762afa51","16":"7cdb14199b376ce8e852","17":"f3c47b32a3406b0ddd94","18":"7cda1ecdd0c04133bf7a","19":"5d64eec0a5db5517d28e","20":"30a4297634e212e38e4b","21":"0d9104147ec8c8d2a601","22":"0625b35ab7d54866599f","23":"9d66876208e837588072","24":"a000f338a044b8e43e0e","25":"67ef24ab4f2dc59d47eb","26":"c7c5142aacc01aa5fdb2","27":"78769992ed05907d30fe","28":"fe680ccd98b8324f5c4c","29":"2f2efc6fe2d0b9198604","30":"7cf866d4582b3bb1c9d5","31":"1918d67409f95b18ec0e","32":"3e37beeb4c7296e1d642","33":"1804f8b0c5fd71f9f6bf","34":"5c4f3946a107dcab3c74","35":"671a4d28b8cc5e861d29","36":"741ef63f825f45ec24ed","37":"f5eee882321b9950e95e","38":"2bfb5ad131e2d2391294","39":"1a77724c47689b0f32e8","40":"6fc9a9abf3c29be12197","41":"9d2c1aa87e7f1838ce89","42":"9ccf7cf957a379aa0e2e","43":"dea404c985f9e62f1c94","44":"0fb590c7025cf3b86296","46":"39b8850ada8c6df30a8c","47":"27b631bf4af381d957de","48":"8ddc16c627b07a7d6a72","49":"0cf9394ca6b219174dea","50":"1c88e485ee114a4e25b7","51":"fe40cbc63666cd3689a8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-locations-LocationsPage-LocationsPage","39":"app-components-search-Search-SearchContainer","40":"app-components-search-SearchPrintList-SearchPrintListContainer","41":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","42":"app-components-shelves-Shelf-ShelfContainer","43":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","44":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"415f85debcee4b00e90f","1":"2e2f20d579f7506e61e5","2":"04675822b9035bad4c9b","3":"eb256da63290cba67cd6","4":"177969e0d4ea13023047","5":"fb7de50083de7561a10e","6":"d067f854c1e3fe1913da","7":"3b227b541f5112933273","8":"dcc07c1abe961fdd1641","9":"681fae6f0fe019ba742b","10":"6e01d2f0fa211ad052e2","11":"154326f599384d6d3efd","12":"1b43193ba3c3709611f2","13":"470cfc0897865b12b042","14":"35c5d1274efb5924daf6","15":"4a430e64ba17762afa51","16":"7cdb14199b376ce8e852","17":"f3c47b32a3406b0ddd94","18":"7cda1ecdd0c04133bf7a","19":"5d64eec0a5db5517d28e","20":"30a4297634e212e38e4b","21":"0d9104147ec8c8d2a601","22":"0625b35ab7d54866599f","23":"9d66876208e837588072","24":"a000f338a044b8e43e0e","25":"67ef24ab4f2dc59d47eb","26":"c7c5142aacc01aa5fdb2","27":"78769992ed05907d30fe","28":"fe680ccd98b8324f5c4c","29":"2f2efc6fe2d0b9198604","30":"7cf866d4582b3bb1c9d5","31":"1918d67409f95b18ec0e","32":"3e37beeb4c7296e1d642","33":"1804f8b0c5fd71f9f6bf","34":"5c4f3946a107dcab3c74","35":"671a4d28b8cc5e861d29","36":"741ef63f825f45ec24ed","37":"f5eee882321b9950e95e","38":"2bfb5ad131e2d2391294","39":"1a77724c47689b0f32e8","40":"6fc9a9abf3c29be12197","41":"9d2c1aa87e7f1838ce89","42":"9ccf7cf957a379aa0e2e","43":"dea404c985f9e62f1c94","44":"0fb590c7025cf3b86296","46":"39b8850ada8c6df30a8c","47":"27b631bf4af381d957de","48":"8ddc16c627b07a7d6a72","49":"0cf9394ca6b219174dea","50":"1c88e485ee114a4e25b7","51":"fe40cbc63666cd3689a8"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2336);
